{
  "$id": "wealthlane://forms/tax-period/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [],
  "observers": [],
  "rules": [
    {
      "id": "rule_effectiveTill_after_effectiveFrom",
      "target": "effectiveTill",
      "rule": "dateAfter",
      "comparedTo": "effectiveFrom",
      "message": "End date must be after start date"
    }
  ]
}
